<template v-if="verificationType">
  <section class="gf-verification-icon" v-if="verificationType !== 'NONE'">
    <gf-custom-tooltip
      :show-on-mobile-version="true"
      width="max-content"
    >
      <template #element>
        <i :class="[verificationIcon, `gf-fs-${size}`]"></i>
      </template>
      <template #content>
        <span>{{ verificationText }}</span>
      </template>
    </gf-custom-tooltip>
  </section>
</template>

<script>
import GfCustomTooltip from '@shared/shared-components/shared/GfCustomTooltip';

export default {
  name: 'GfVerificationIcon',
  components: { GfCustomTooltip },
  props: {
    size: {
      type: String,
      default: '3'
    },
    verificationType: {
      type: String,
      default: null
    },
    basicVerificationTitle: {
      type: String,
      default() {
        return this.$t('message.verificated');
      }
    }
  },
  computed: {
    verificationIcon() {
      switch (this.verificationType) {
        case 'NONE':
          return
        case 'DEFAULT':
          return 'gf-icon gf-icon-check-star text-primary';
        case 'GITFLIC':
          return 'gf-icon gf-icon-gf-logo-with-background';
        default:
          return 'gf-icon gf-icon-check-star';
      }
    },
    verificationText() {
      switch (this.verificationType) {
        case 'NONE':
          return
        case 'DEFAULT':
          return this.basicVerificationTitle;
        case 'GITFLIC':
          return this.$t('message.inGitflicTeam');
        default:
          return this.basicVerificationTitle;
      }
    }
  }
};
</script>
